URL = '/customer/conversations/%CONVERSATION_ID%/notes'

class Customer.Note extends Backbone.Model

  created_at: ->
    return @get('created_at')

  ticketType: ->
    return 'note'

  userCanModify: ->
    Keepcon.current_user.id == @attributes.user_id

  uniqueId: ->
    'note_event_' + @get('id')

class Customer.NotesCollection extends Backbone.Collection
  model: Customer.Note
  comparator: 'created_at'

  initialize: (models = null, options = {}) ->
    throw 'Error: cannot create a NotesCollection without a conversation ID' unless options.conversation_id
    @conversation_id = options.conversation_id
    super

  url: ->
    URL.replace('%CONVERSATION_ID%', @conversation_id)
